/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { MobileDropdownMenu } from "components/header/header-nav-bar/mobile-menu/mobile-dropdown-menu";
import { ReactComponent as Bars } from "cms/assets/icons/bars.svg";
import { ReactComponent as CloseMenu } from "cms/assets/icons/xmark.svg";

const MobileMenu = () => {

    const [showDropdown, setShowDropdown] = useState(false);

    const toggleMobileDropdown = () => {
        setShowDropdown((prev) => !prev);
    };

    return (
        <div className="mobile-menu">
            <button className="mobile-menu-btn" onClick={toggleMobileDropdown}>
                {showDropdown &&
                    <>
                        <CloseMenu alt="close-menu-icon" />
                        <span>Close</span>
                    </>
                }
                {!showDropdown &&
                    <>
                        <Bars alt="menu-bars" />
                        <span>Menu</span>
                    </>
                }
            </button>
            <MobileDropdownMenu show={showDropdown} />
        </div>
    );
};

export { MobileMenu };
